import * as React from 'react';
import {Outlet} from 'react-router';

import {EmptySidenavLayout, GlobalSidenavLayout} from './index';

export const GlobalSidenavLayoutOutlet = () => {
  return (
    <GlobalSidenavLayout>
      <Outlet />
    </GlobalSidenavLayout>
  );
};

export const EmptySidenavLayoutOutlet = () => {
  return (
    <EmptySidenavLayout>
      <Outlet />
    </EmptySidenavLayout>
  );
};
